import { render, staticRenderFns } from "./DetailConfigDatasetGroupListItem.vue?vue&type=template&id=5f7c01b4"
import script from "./DetailConfigDatasetGroupListItem.vue?vue&type=script&lang=js"
export * from "./DetailConfigDatasetGroupListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports